import React from 'react'
import './Contact.css'
import lagos from "../assets/lagos.jpg"
import Navbar from '../Navbar'
import Footer from '../Footer'

const Contact = () => {
  return (
    <>
    <Navbar />
    <section className='contact-title'>
      <h1>Contact Us</h1>

      <div className="location">
        <h2>Lagos</h2>
        <div className="address">
          <img src={lagos} alt="" />
          <div className="info" style={{lineHeight: "1"}}>
            <p>Augere Offshore</p>
            <p>Unit 1 Plot No. 36 Land Bridge Avenue</p>
            <p>Oniru Estate, Victoria Island Annex</p>
            <p>Lagos, Nigeria</p>
            <a href='mailto:hello@augereoffshore.com'>hello@augereoffshore.com</a>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}

export default Contact